module.exports = __webpack_public_path__ + "static/media/Win.0f426159.png";